import { Container } from '@mui/material';
import useSettings from '../../hooks/useSettings';
import Page from '../../components/Page';
import Covid19PolicyPriceForm from 'components/insurance/step-1/Covid19PolicyPriceForm';
import { useTranslations } from 'hooks/useTranslations';
import { TravelCancellationPolicyStepper } from 'components/insurance/components/TravelCancellationPolicyStepper';

export default function TravelCancellationInsuranceStep1() {
  const translations = useTranslations();
  const { themeStretch } = useSettings();

  return (
    <Page title={translations.policy.travelCancellation.title()}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <TravelCancellationPolicyStepper heading={translations.policy.travelCancellation.title()} currentStep={0} />

        <Covid19PolicyPriceForm />
      </Container>
    </Page>
  );
}
